module.exports = __webpack_public_path__ + "static/media/3d-rendering-modern-house-with-terrace-at-night-82BV93Z.a4524625.jpg";